export const MAX_WORKSPACE_TABS = 10;

export type WorkspaceTab = {
  key: string;
  pathname: string;
  search: string;
  title: string;
};

export type WorkspaceTabsState = {
  tabs: WorkspaceTab[];
  activeKey: string | null;
};

export enum WorkspaceTabsActionTypes {
  OPEN_TAB = '@@workspaceTabs/OPEN_TAB',
  ACTIVATE_TAB = '@@workspaceTabs/ACTIVATE_TAB',
  CLOSE_TAB = '@@workspaceTabs/CLOSE_TAB',
  UPDATE_TAB_TITLE = '@@workspaceTabs/UPDATE_TAB_TITLE',
  CLEAR_TABS = '@@workspaceTabs/CLEAR_TABS',
}
